// extracted by mini-css-extract-plugin
export default {"cls1":"Page-cls1___64d364f8167ab28b779","cls2":"Page-cls2___1633ed9c7591d9435f5 Page-cls1___64d364f8167ab28b779"};